const config = {
    apiUrl: 'https://api.eldt.com/api',
    googleSignIn: 'https://api.eldt.com/oauth/google?target=react',
    angularClientUrl: 'https://app.eldt.com',
    amplitudeApiKey: '',
    defaultCompanyId: 22,
    defaultLocationId: 23,
    packageIds: {
        'Class A': 1,
        'Class B': 2,
        'Class B-A': 3,
        'None': 4,
    },
    stripePublicKey: 'pk_live_51KVilWEqooDHZwmc8DlxRV5iqAlrSC0Flw6BGCkk3fM8k3Jovn1WRALFiFfsS9mpaoNqRIB2NHZaUsP290fs3VJt00RldOmFqp',
    sentryKey: 'https://3bc1b8796a1a55caad7558064170639b@o4503932842999808.ingest.us.sentry.io/4508354754379776',
}

export default config;
